export default __webpack_public_path__ + "static/media/loop.76eff6f9.svg";